import React, {useContext} from 'react';
import OutputLine from "./OutputLine";
import MobXContext from "../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import IconTypes from "../Input/IconInput/IconTypes";
import PropTypes from "prop-types";
import IconMenuOutput from "./IconMenuOutput";
import escapeOutputString from "../../../misc/escapeOutputString";
import POPUP_MENU_STYLE from "../../../../../../src/js/misc/popupMenuStyle";

const propTypes = {
	baseIndent: PropTypes.number.isRequired,
	iconName: PropTypes.string.isRequired,
};
const defaultProps = {};

const hasSetting = (configuratorStore, iconName) => (
	configuratorStore[`${iconName}IconType`] !== IconTypes.none &&
	(
		(configuratorStore[`${iconName}IconOnHover`] || configuratorStore[`${iconName}IconTitle`] || configuratorStore[`${iconName}IconShowTitle`]) ||
		(configuratorStore[`${iconName}IconType`] === IconTypes.onClick && configuratorStore[`${iconName}IconOnClick`]) ||
		(configuratorStore[`${iconName}IconType`] === IconTypes.popupContent && configuratorStore[`${iconName}IconPopupContent`]) ||
		(configuratorStore[`${iconName}IconType`] === IconTypes.menu && configuratorStore[`${iconName}IconMenu`])
	)
);

const IconOutput = ({baseIndent, iconName}) => {
	const {configuratorStore} = useContext(MobXContext);

	return (
		hasSetting(configuratorStore, iconName) ?
			<>
				<OutputLine indent={baseIndent}>
					{`${iconName}Icon: {`}
				</OutputLine>

				{
					configuratorStore[`${iconName}IconOnHover`] ?
						<OutputLine indent={baseIndent + 1} highlightableField={`${iconName}IconOnHover`}>
							{`onHover: ${configuratorStore[`${iconName}IconOnHover`]},`}
						</OutputLine>
						: undefined
				}

				{
					configuratorStore[`${iconName}IconTitle`] ?
						<OutputLine indent={baseIndent + 1} highlightableField={`${iconName}IconTitle`}>
							{`title: '${escapeOutputString(configuratorStore[`${iconName}IconTitle`])}',`}
						</OutputLine>
						: undefined
				}

				{
					configuratorStore[`${iconName}IconShowTitle`] ?
						<OutputLine indent={baseIndent + 1} highlightableField={`${iconName}IconShowTitle`}>
							{`showTitle: ${configuratorStore[`${iconName}IconShowTitle`] || false},`}
						</OutputLine>
						: undefined
				}

				{
					(configuratorStore[`${iconName}IconOnClick`] && configuratorStore[`${iconName}IconType`] === IconTypes.onClick) ?
						<OutputLine indent={baseIndent + 1} highlightableField={`${iconName}IconOnClick`}>
							{`onClick: ${configuratorStore[`${iconName}IconOnClick`]},`}
						</OutputLine>
						: undefined
				}

				{
					(configuratorStore[`${iconName}IconPopupContent`] && configuratorStore[`${iconName}IconType`] === IconTypes.popupContent) ?
						<OutputLine indent={baseIndent + 1} highlightableField={`${iconName}IconPopupContent`}>
							{`popupContent: window.utahHeader.renderDOM(\'${escapeOutputString(configuratorStore[`${iconName}IconPopupContent`])}\'),`}
						</OutputLine>
						: undefined
				}

				{
					(configuratorStore[`${iconName}IconMenuStyle`] && configuratorStore[`${iconName}IconType`] === IconTypes.menu) ?
						<OutputLine indent={baseIndent + 1} highlightableField={`${iconName}IconMenuStyle`}>
							{`menuStyle: window.utahHeader.POPUP_MENU_STYLE.${Object.keys(POPUP_MENU_STYLE).filter(key => POPUP_MENU_STYLE[key] === configuratorStore[`${iconName}IconMenuStyle`])[0]},`}
						</OutputLine>
						: undefined
				}

				{
					(configuratorStore[`${iconName}IconMenu`] && configuratorStore[`${iconName}IconType`] === IconTypes.menu) ?
						<IconMenuOutput menu={configuratorStore[`${iconName}IconMenu`]} indentLevel={baseIndent + 1} isHighlighted={configuratorStore.lastChangedField === `${iconName}IconType`}/>
						: undefined
				}

				<OutputLine indent={baseIndent}>
					{`},`}
				</OutputLine>
			</>
			: null
	);
};

IconOutput.propTypes = propTypes;
IconOutput.defaultProps = defaultProps;

export default observer(IconOutput);
